import { Injectable } from "@angular/core";
import { SharedService } from "./shared.service";
import { HttpClient } from "@angular/common/http";
import { ProductRating } from "../models/productAuth";
@Injectable({
  providedIn: "root",
})
export class ProductAuthService {
  url;
  constructor(
    private sharedService: SharedService,
    private httpClient: HttpClient
  ) {
    this.url = sharedService.baseURL;
  }

  productAuthData(productAuthData: any): any {
    return this.httpClient.post<any>(
      `${this.url}/api/PA/Verify`,
      productAuthData
    );
  }
  getCustomFieldDetails(companyId): any {
    return this.httpClient.get<any>(
      `${this.url}/api/CustomizePage/GetCustomFieldDetails?companyId=${companyId}`
    );
  }
  hiProductAuthData(productAuthData: any): any {
    return this.httpClient.post<any>(
      `${this.url}/api/HIProductAuthentication/Verify`,
      productAuthData
    );
  }
  MPPKVVCLProductAuthData(productAuthData: any): any {
    return this.httpClient.post<any>(
      `${this.url}/api/MPPKVVCLAuthentication/Verify`,
      productAuthData
    );
  }
  TamilnaduRiceProductAuthData(productAuthData: any): any {
    return this.httpClient.post<any>(
      `${this.url}/api/TamilNaduRice/Verify`,
      productAuthData
    );
  }
  TNGetDetails(productAuthData: any): any {
    return this.httpClient.post<any>(
      `${this.url}/api/TamilNaduRice/GetDetails`,
      productAuthData
    );
  }
  reverseGeoCode(lat: number, long: number) {
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<any>(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${long}&zoom=18&addressdetails=1`
    );
  }
  saveRating(rate: ProductRating): any {
    return this.httpClient.post<any>(`${this.url}/api/PA/SaveRating`, rate);
  }
  saveFeedback(data: any) {
    return this.httpClient.post<any>(`${this.url}/api/PA/Feedback`, data);
  }
  getAllSimilarProducts(data: any) {
    return this.httpClient.post<any>(
      `${this.url}/api/PA/GetAllSimilarProducts`,
      data
    );
  }

  feedBackOnFakeVerification(formData: FormData) {
    return this.httpClient.post<any>(
      `${this.url}/api/PA/FeedBackOnFakeVerification`,
      formData
    );
  }
  getVerificationHistory(verificationHistories: any) {
    return this.httpClient.post<any>(
      `${this.url}/api/PA/GetVerificationHistory`,
      verificationHistories
    );
  }

  loadCompaniesDDL(): any {
    return this.httpClient.get<any>(`${this.url}/api/PA/GetCompaniesDDL`);
  }

  uploadAudio(formData: FormData): any {
    return this.httpClient.post<any>(
      `${this.url}/api/Utility/AudioFileUpload`,
      formData
    );
  }

  sendWhatsApp(): any {
    return this.httpClient.get<any>(`${this.url}/api/WhatsApp/WhatsAppTrigger`);
  }

  GetPatanjaliData(data: any): any {
    return this.httpClient.post<any>(
      `${this.url}/api/PA/GetPatanjaliData`,
      data
    );
  }
}
